export default "__VITE_ASSET__27c67718__"